import React, { useState, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchItemById } from 'src/store/actions/items';
import { PATHS } from 'src/common/constants';
import { selectItemById } from 'src/store/selectors/items';
import { setItemFormData } from 'src/store/actions/itemForm';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';
import Card from '../../components/Card';
import HeadingWithDetails from '../../components/HeadingWithDetails';
import FontAwesomeIcon from '../../components/Icon';
import ItemDocuments from './ItemDocuments';
import ItemMaintenanceGuide from './ItemMaintenanceGuide';
import ItemFaqs from './ItemFaqs';
import ItemForm from '../../components/ItemForm';
import ItemNotes from './ItemNotes';
import ItemCommonIssues from './ItemCommonIssues';
import Loader from '../../components/Loader';
import Metrics from '../../components/Metrics';
import Overlay from '../../components/Overlay';
import Tabs from '../../components/Tabs';
import Warranty from '../../components/Warranty';
import WithNavigation from '../../layouts/WithNavigation';
import { clearServiceRequests } from 'src/store/actions/serviceRequests';
import { fetchAllIssueTypes } from 'src/store/actions/formOptions';
import { deleteItem, updateItem } from 'src/store/actions/items';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import ItemServiceRequest from './ItemServiceRequest';
import { fetchCommonIssues } from 'src/store/actions/CommonIssues';
import { selectCommonIssues } from 'src/store/selectors/CommonIssues';
import ItemSpecifications from './ItemSpecifications';
import { BrandingContext } from 'src/branding/BrandingContextProvider';
import {
  ItemNotesProvider,
  useItemNotesActionsFromContext,
  useItemNotesDataFromContext,
} from './Context/ItemNotesProvider';

const ItemInner = (props: any) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [
    noteVisibleToHomeownerOccupantRealtor,
    setNoteVisibleToHomeownerOccupantRealtor,
  ] = useState(false);

  const item = useSelector((state: any) =>
    selectItemById(state, props.match.params.id)
  );
  const user = useSelector(selectAuthenticatedUser);
  const commonIssues = useSelector(selectCommonIssues);

  const { notes } = useItemNotesDataFromContext();
  const { fetchNotes } = useItemNotesActionsFromContext();

  const dispatch = useDispatch();

  const { branding } = useContext(BrandingContext);

  useEffect(() => {
    dispatch(clearServiceRequests());
    dispatch(fetchAllIssueTypes());
    dispatch(fetchCommonIssues(item.id));
    fetchNotes(item.id);

    let HmeOwnrOcpntRltrNotes = [];

    if (notes && Array.isArray(notes) && notes.length > 0) {
      let notesList = notes.filter((x) => x.documentType == 'NOTES');

      if (notesList.length > 0) {
        notesList.forEach((object) => {
          HmeOwnrOcpntRltrNotes.push(
            JSON.parse(JSON.parse(JSON.stringify(object.data)))
          );
        });
      }

      if (HmeOwnrOcpntRltrNotes.length > 0) {
        let filterNotes = HmeOwnrOcpntRltrNotes.filter(
          (x) => x.noteVisibleToHomeownerOccupantRealtor == true
        );

        if (filterNotes.length > 0) {
          setNoteVisibleToHomeownerOccupantRealtor(true);
        }
      }
    }
  }, []);

  const onSaveItem = (item: any) => {
    let params = {};
    let properties = [];

    if (item.selectedProperties && item.selectedProperties.length > 0) {
      item.selectedProperties.map((sp: any) => {
        properties = [...properties, { id: sp.value }];
      });
    }

    if (item.id) {
      params = {
        id: item.id,
        name: item.name,
        MakeName: item.makeName,
        model: item.model,
        TypeId: item.typeId,
        warrantyYears: item.warrantyYears,
        UserId: user.id,
        properties: properties,
      };
      dispatch(updateItem(params));
    }
  };

  const onDeleteItem = (data: any) => {
    dispatch(deleteItem(data.id, props.history));
  };

  const onFetchItemData = async () => {
    if (item?.id) {
      dispatch(fetchItemById(item.id));
    }
  };

  const localUser = JSON.parse(localStorage.getItem('user'));
  let roleName = localUser.roles[0].role.name;

  if (item) {
    return (
      <WithNavigation
        title={item.name}
        top={
          <HeadingWithDetails
            breadcrumb={<Breadcrumb to={PATHS.ITEMS_LIST} label="Catalog" />}
            headline={item.name}
            items={[
              <Card
                body={
                  <>
                    MAKE: {item && item.makeName ? item.makeName : '—'} <br />
                    MODEL: {item && item.model ? item.model : '—'} <br />
                    TYPE: {item.typeName}
                  </>
                }
              />,
              <Metrics
                items={[
                  {
                    value: item.serviceRequestsCount,
                  },
                ]}
                title={null}
              />,
              <Card
                title="Warranty Plan"
                body={<Warranty duration={item.warrantyYears} />}
              />,
            ]}
            actions={
              localUser.roles[0].role.name === 'Strata Manager' ? null : (
                <>
                  <Button
                    color="semantic"
                    onClick={() => {
                      setShowOverlay(true);
                      dispatch(
                        setItemFormData({
                          ...item,
                          selectedProperties: item.properties.map(
                            (pty: any) => ({
                              value: pty.id,
                              label: pty.name,
                            })
                          ),
                        })
                      );
                    }}
                    label={<FontAwesomeIcon glyph="pencil" weight="light" />}
                  />
                  <Button
                    color="semantic"
                    onClick={() =>
                      window.confirm(
                        `Are you sure you want to delete ${item.name}?`
                      ) && onDeleteItem(item)
                    }
                    label={<FontAwesomeIcon glyph="trash" weight="light" />}
                  />
                  <Overlay
                    showOverlay={showOverlay}
                    content={
                      <ItemForm
                        onClose={() => setShowOverlay(false)}
                        onSaveItem={onSaveItem}
                        onDeleteItem={onDeleteItem}
                      />
                    }
                  />
                </>
              )
            }
          />
        }
        bottom={
          <Tabs
            from={'Catalog'}
            items={[
              {
                label: 'Specifications',
                count: item.faq_count,
                content: <ItemSpecifications item={item} />,
              },
              {
                label: 'FAQs',
                count: item.faq_count,
                content: <ItemFaqs item={item} />,
              },
              (roleName === 'Occupant' ||
                roleName === 'Realtor' ||
                roleName === 'Home Owner') &&
              noteVisibleToHomeownerOccupantRealtor == false
                ? {}
                : {
                    label: 'Notes',
                    count: notes?.length > 0 ? notes.length : '',
                    content: (
                      <ItemNotes
                        item={item}
                        onFetchItemData={onFetchItemData}
                      />
                    ),
                  },
              {
                label: 'Manuals & Documents',
                count: item.document_count,
                content: <ItemDocuments item={item} />,
              },
              {
                label: branding.text.serviceRequest + 's',
                count: item.document_count,
                content: <ItemServiceRequest item={item} />,
              },
              {
                label: 'Maintenance Reminders',
                count: item.document_count,
                content: <ItemMaintenanceGuide item={item} />,
              },
              {
                label: 'Common Issues',
                count: commonIssues.length.toString(),
                content: (
                  <ItemCommonIssues item={item} commonIssues={commonIssues} />
                ),
              },
            ]}
          />
        }
      />
    );
  }

  return <Loader />;
};

const Item = (props: any) => {
  return (
    <ItemNotesProvider>
      <ItemInner {...props} />
    </ItemNotesProvider>
  );
};

export default Item;
